export const categories = [
  { slug: "shaonian", name: "少年漫画", icon: "ri-user-smile-line", description: "热血、冒险、战斗类少年向漫画", count: 156 },
  { slug: "shaonv", name: "少女漫画", icon: "ri-heart-line", description: "浪漫、校园、情感类少女向漫画", count: 128 },
  { slug: "danmei", name: "耽美漫画", icon: "ri-star-line", description: "BL向恋爱题材漫画", count: 203 },
  { slug: "qihuan", name: "奇幻漫画", icon: "ri-magic-line", description: "魔法、异世界、幻想类漫画", count: 97 },
  { slug: "xuanyi", name: "悬疑漫画", icon: "ri-search-eye-line", description: "推理、惊悚、悬疑类漫画", count: 84 },
  { slug: "xiju", name: "喜剧漫画", icon: "ri-emotion-laugh-line", description: "搞笑、日常、轻松类漫画", count: 112 },
  { slug: "dongzuo", name: "动作漫画", icon: "ri-flashlight-line", description: "格斗、武术、竞技类漫画", count: 76 },
  { slug: "kongbu", name: "恐怖漫画", icon: "ri-ghost-line", description: "灵异、恐怖、惊悚类漫画", count: 63 },
];

export const comics = [
  {
    id: "duzhe-mianxiang",
    slug: "duzhe-mianxiang",
    title: "读者面向",
    originalTitle: "독자님의 시선",
    author: "金智恩",
    artist: "朴民秀",
    category: "耽美漫画",
    categorySlug: "danmei",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20comic%20cover%20style%20two%20handsome%20male%20characters%20facing%20each%20other%20with%20intense%20gaze%20soft%20warm%20lighting%20digital%20art%20illustration%20clean%20background%20vibrant%20colors&width=600&height=800&seq=comic-cover-01&orientation=portrait",
    description: "顶级偶像与普通读者的命运交织，一段跨越身份的爱恋即将展开。当红偶像团体成员李在贤在一次粉丝见面会上，遇见了与众不同的读者金多云，两人之间擦出了意想不到的火花。",
    tags: ["偶像", "恋爱", "职场", "甜宠"],
    rating: 9.6,
    views: 3250000,
    chapters: 87,
    status: "连载中",
    updatedAt: "2026-08-03",
    featured: true,
    chapters_list: [
      { num: 87, title: "第87话 - 深夜的约定", date: "2026-08-03" },
      { num: 86, title: "第86话 - 秘密被发现", date: "2026-07-27" },
      { num: 85, title: "第85话 - 心动的瞬间", date: "2026-07-20" },
      { num: 84, title: "第84话 - 命运的转折", date: "2026-07-13" },
      { num: 83, title: "第83话 - 无法言说的情感", date: "2026-07-06" },
      { num: 82, title: "第82话 - 星光下的告白", date: "2026-06-29" },
    ],
  },
  {
    id: "anlian-chengzhen",
    slug: "anlian-chengzhen",
    title: "暗恋成真",
    originalTitle: "짝사랑이 이루어졌다",
    author: "李秀雅",
    artist: "郑允浩",
    category: "少女漫画",
    categorySlug: "shaonv",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20romance%20comic%20cover%20style%20young%20female%20student%20with%20long%20hair%20blushing%20under%20cherry%20blossom%20tree%20soft%20pastel%20colors%20digital%20illustration%20clean%20simple%20background&width=600&height=800&seq=comic-cover-02&orientation=portrait",
    description: "高中三年级的韩素熙一直暗恋着同班的校园男神金秀赫，本以为这份感情永远不会有结果，却在一个雨天的放学后，收到了他递来的纸条。一场甜蜜的校园恋爱故事就此展开。",
    tags: ["校园", "暗恋", "甜蜜", "青春"],
    rating: 9.4,
    views: 4580000,
    chapters: 65,
    status: "已完结",
    updatedAt: "2026-07-15",
    featured: true,
    chapters_list: [
      { num: 65, title: "第65话 - 最终回：我们的未来", date: "2026-07-15" },
      { num: 64, title: "第64话 - 毕业典礼", date: "2026-07-08" },
      { num: 63, title: "第63话 - 最后的暑假", date: "2026-07-01" },
      { num: 62, title: "第62话 - 大学志愿", date: "2026-06-24" },
      { num: 61, title: "第61话 - 父母的认可", date: "2026-06-17" },
    ],
  },
  {
    id: "jiansheng-zhigao",
    slug: "jiansheng-zhigao",
    title: "剑圣至高",
    originalTitle: "소드 마스터 슈프림",
    author: "崔东旭",
    artist: "金泰亨",
    category: "少年漫画",
    categorySlug: "shaonian",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20fantasy%20comic%20cover%20style%20male%20warrior%20with%20sword%20standing%20in%20epic%20pose%20magical%20aura%20surrounding%20him%20dark%20dramatic%20lighting%20digital%20art%20illustration%20clean%20background&width=600&height=800&seq=comic-cover-03&orientation=portrait",
    description: "被封印千年的剑圣重生到现代世界，曾经的最强者发现自己的力量被大幅削弱。为了恢复昔日的巅峰，他必须在全新的世界中重新修炼，同时应对来自各方势力的威胁。",
    tags: ["重生", "剑术", "奇幻", "战斗"],
    rating: 9.5,
    views: 6120000,
    chapters: 124,
    status: "连载中",
    updatedAt: "2026-08-02",
    featured: true,
    chapters_list: [
      { num: 124, title: "第124话 - 决战前夕", date: "2026-08-02" },
      { num: 123, title: "第123话 - 黑暗来袭", date: "2026-07-26" },
      { num: 122, title: "第122话 - 最后的试炼", date: "2026-07-19" },
      { num: 121, title: "第121话 - 剑魂觉醒", date: "2026-07-12" },
    ],
  },
  {
    id: "mofa-shaonv",
    slug: "mofa-shaonv",
    title: "魔法少女的日常",
    originalTitle: "마법소녀의 일상",
    author: "张美娜",
    artist: "韩智敏",
    category: "奇幻漫画",
    categorySlug: "qihuan",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20magical%20girl%20fantasy%20comic%20cover%20style%20cute%20female%20character%20with%20magical%20wand%20floating%20in%20colorful%20starry%20sky%20sparkles%20and%20stars%20whimsical%20digital%20art%20illustration%20clean%20background&width=600&height=800&seq=comic-cover-04&orientation=portrait",
    description: "普通女高中生林小夜意外获得魔法力量，从此开始了白天上学、晚上打怪的忙碌生活。然而她发现，最大的挑战不是那些怪物，而是如何在魔法任务和期末考试之间找到平衡。",
    tags: ["魔法", "校园", "日常", "搞笑"],
    rating: 8.9,
    views: 1890000,
    chapters: 42,
    status: "连载中",
    updatedAt: "2026-07-30",
    featured: false,
    chapters_list: [
      { num: 42, title: "第42话 - 魔法考试周", date: "2026-07-30" },
      { num: 41, title: "第41话 - 新的伙伴", date: "2026-07-23" },
      { num: 40, title: "第40话 - 暗影来袭", date: "2026-07-16" },
    ],
  },
  {
    id: "yinying-chengbao",
    slug: "yinying-chengbao",
    title: "阴影城堡",
    originalTitle: "그림자 성",
    author: "姜赫",
    artist: "宋智勋",
    category: "悬疑漫画",
    categorySlug: "xuanyi",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20thriller%20comic%20cover%20style%20dark%20gothic%20castle%20silhouette%20with%20moonlight%20mysterious%20atmosphere%20shadowy%20figure%20in%20foreground%20eerie%20digital%20art%20illustration%20clean%20background&width=600&height=800&seq=comic-cover-05&orientation=portrait",
    description: "记者崔敏赫收到一封神秘邀请函，被邀请到一座与世隔绝的古堡采访。当他抵达后，一连串诡异的事件开始发生，城堡中的每个人似乎都隐藏着不可告人的秘密。",
    tags: ["悬疑", "恐怖", "推理", "黑暗"],
    rating: 9.2,
    views: 2340000,
    chapters: 56,
    status: "连载中",
    updatedAt: "2026-08-01",
    featured: false,
    chapters_list: [
      { num: 56, title: "第56话 - 真相浮现", date: "2026-08-01" },
      { num: 55, title: "第55话 - 密室之谜", date: "2026-07-25" },
      { num: 54, title: "第54话 - 第十三位客人", date: "2026-07-18" },
    ],
  },
  {
    id: "chaoneng-zhandou",
    slug: "chaoneng-zhandou",
    title: "超能战斗学院",
    originalTitle: "초능력 배틀 아카데미",
    author: "尹在赫",
    artist: "金俊秀",
    category: "动作漫画",
    categorySlug: "dongzuo",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20superpower%20comic%20cover%20style%20multiple%20young%20characters%20with%20energy%20powers%20dynamic%20fighting%20pose%20explosive%20effects%20vibrant%20action%20digital%20art%20illustration%20clean%20background&width=600&height=800&seq=comic-cover-06&orientation=portrait",
    description: "在一个超能力者被社会接受的世界里，韩国最顶尖的超能战斗学院每年只招收最优秀的学生。主角朴武烈虽然出身平凡，却凭借不屈的意志和独特的战斗天赋，一步步走向学院的巅峰。",
    tags: ["超能力", "学院", "战斗", "热血"],
    rating: 9.1,
    views: 3780000,
    chapters: 98,
    status: "连载中",
    updatedAt: "2026-08-02",
    featured: true,
    chapters_list: [
      { num: 98, title: "第98话 - 总决赛开始", date: "2026-08-02" },
      { num: 97, title: "第97话 - 半决赛激战", date: "2026-07-26" },
      { num: 96, title: "第96话 - 突破极限", date: "2026-07-19" },
    ],
  },
  {
    id: "shejiao-kongbu",
    slug: "shejiao-kongbu",
    title: "社交恐怖故事",
    originalTitle: "소셜 호러 스토리",
    author: "权志龙",
    artist: "李东勋",
    category: "恐怖漫画",
    categorySlug: "kongbu",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20comic%20cover%20style%20creepy%20phone%20screen%20with%20ghostly%20face%20reflected%20dark%20room%20atmosphere%20cold%20blue%20tones%20digital%20art%20illustration%20clean%20background&width=600&height=800&seq=comic-cover-07&orientation=portrait",
    description: "一群大学生发现了一个神秘的社交应用，据说只要在上面发布恐怖故事，故事就会在现实中成真。起初他们只把这当作玩笑，直到第一个故事真的发生了……",
    tags: ["恐怖", "社交媒体", "都市传说", "惊悚"],
    rating: 8.7,
    views: 1560000,
    chapters: 38,
    status: "连载中",
    updatedAt: "2026-07-28",
    featured: false,
    chapters_list: [
      { num: 38, title: "第38话 - 最后一个帖子", date: "2026-07-28" },
      { num: 37, title: "第37话 - 无法删除", date: "2026-07-21" },
      { num: 36, title: "第36话 - 深夜直播", date: "2026-07-14" },
    ],
  },
  {
    id: "gaoxiao-richang",
    slug: "gaoxiao-richang",
    title: "搞笑日常大作战",
    originalTitle: "개그 일상 대작전",
    author: "安成民",
    artist: "崔真赫",
    category: "喜剧漫画",
    categorySlug: "xiju",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20slice%20of%20life%20comic%20cover%20style%20funny%20exaggerated%20facial%20expressions%20of%20characters%20bright%20colorful%20cartoon%20style%20playful%20digital%20art%20illustration%20clean%20background&width=600&height=800&seq=comic-cover-08&orientation=portrait",
    description: "四个性格迥异的室友住在一起，每天都会发生各种令人捧腹的搞笑事件。从做饭失败到约会翻车，每一个日常都能变成一场喜剧盛宴。",
    tags: ["搞笑", "日常", "宿舍", "治愈"],
    rating: 9.0,
    views: 2870000,
    chapters: 71,
    status: "连载中",
    updatedAt: "2026-08-03",
    featured: false,
    chapters_list: [
      { num: 71, title: "第71话 - 外卖乌龙事件", date: "2026-08-03" },
      { num: 70, title: "第70话 - 健身房糗事", date: "2026-07-27" },
      { num: 69, title: "第69话 - 相亲大作战", date: "2026-07-20" },
    ],
  },
  {
    id: "xingchen-bianjing",
    slug: "xingchen-bianjing",
    title: "星辰边境",
    originalTitle: "스타 프론티어",
    author: "金敏俊",
    artist: "郑宇成",
    category: "少年漫画",
    categorySlug: "shaonian",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20sci-fi%20space%20comic%20cover%20style%20futuristic%20spaceship%20and%20stars%20with%20young%20pilot%20in%20space%20suit%20epic%20galaxy%20background%20digital%20art%20illustration%20clean%20composition&width=600&height=800&seq=comic-cover-09&orientation=portrait",
    description: "公元2350年，人类已经遍布银河系。年轻的星际探险家金宇镇奉命前往未知星域执行一项秘密任务，却发现了一个足以改变人类命运的重大秘密。",
    tags: ["科幻", "太空", "冒险", "热血"],
    rating: 9.3,
    views: 1980000,
    chapters: 53,
    status: "连载中",
    updatedAt: "2026-07-31",
    featured: false,
    chapters_list: [
      { num: 53, title: "第53话 - 异星文明", date: "2026-07-31" },
      { num: 52, title: "第52话 - 虫洞另一端", date: "2026-07-24" },
      { num: 51, title: "第51话 - 求救信号", date: "2026-07-17" },
    ],
  },
  {
    id: "jiaohuan-rensheng",
    slug: "jiaohuan-rensheng",
    title: "交换人生",
    originalTitle: "인생 스왑",
    author: "李贤宇",
    artist: "金秀珍",
    category: "耽美漫画",
    categorySlug: "danmei",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20body%20swap%20romance%20comic%20cover%20style%20two%20male%20characters%20one%20wealthy%20one%20poor%20looking%20at%20each%20other%20with%20surprise%20expression%20elegant%20digital%20art%20illustration%20clean%20background&width=600&height=800&seq=comic-cover-10&orientation=portrait",
    description: "财阀继承人和普通打工人的灵魂意外互换，两个原本毫无交集的人被迫进入对方的生活。在适应过程中，他们逐渐了解彼此，也发现了隐藏在身份背后的真挚情感。",
    tags: ["灵魂互换", "财阀", "职场", "治愈"],
    rating: 9.5,
    views: 4010000,
    chapters: 72,
    status: "已完结",
    updatedAt: "2026-06-20",
    featured: true,
    chapters_list: [
      { num: 72, title: "第72话 - 最终回：回归与选择", date: "2026-06-20" },
      { num: 71, title: "第71话 - 告白", date: "2026-06-13" },
      { num: 70, title: "第70话 - 真相大白", date: "2026-06-06" },
    ],
  },
  {
    id: "huanjing-shijie",
    slug: "huanjing-shijie",
    title: "幻境世界",
    originalTitle: "일루전 월드",
    author: "韩胜宇",
    artist: "赵敏基",
    category: "奇幻漫画",
    categorySlug: "qihuan",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20adventure%20comic%20cover%20style%20young%20hero%20standing%20at%20entrance%20of%20magical%20portal%20with%20vibrant%20fantasy%20landscape%20on%20other%20side%20mystical%20digital%20art%20illustration%20clean%20background&width=600&height=800&seq=comic-cover-11&orientation=portrait",
    description: "一款名为「幻境」的全息游戏风靡全球，玩家可以通过神经连接完全沉浸在虚拟世界中。高中生韩俊昊在游戏中偶然触发了一个隐藏任务，却发现游戏世界与现实的界限正在逐渐模糊。",
    tags: ["游戏", "异世界", "冒险", "科幻"],
    rating: 9.1,
    views: 2670000,
    chapters: 81,
    status: "连载中",
    updatedAt: "2026-08-01",
    featured: false,
    chapters_list: [
      { num: 81, title: "第81话 - 世界融合", date: "2026-08-01" },
      { num: 80, title: "第80话 - 最终BOSS", date: "2026-07-25" },
      { num: 79, title: "第79话 - 隐藏真相", date: "2026-07-18" },
    ],
  },
  {
    id: "yiwai-zhenxiang",
    slug: "yiwai-zhenxiang",
    title: "意外真相",
    originalTitle: "뜻밖의 진실",
    author: "朴镇宇",
    artist: "李彩英",
    category: "悬疑漫画",
    categorySlug: "xuanyi",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20crime%20mystery%20comic%20cover%20style%20detective%20looking%20at%20evidence%20board%20with%20red%20strings%20connecting%20photos%20noir%20atmosphere%20digital%20art%20illustration%20clean%20background&width=600&height=800&seq=comic-cover-12&orientation=portrait",
    description: "新人刑警金素英接手了一桩看似普通的失踪案件，随着调查的深入，她发现这背后牵扯到一个庞大的犯罪组织。更令她震惊的是，案件的关键线索竟然指向自己的家人。",
    tags: ["刑侦", "犯罪", "悬疑", "反转"],
    rating: 9.4,
    views: 3120000,
    chapters: 49,
    status: "连载中",
    updatedAt: "2026-08-02",
    featured: true,
    chapters_list: [
      { num: 49, title: "第49话 - 家人的秘密", date: "2026-08-02" },
      { num: 48, title: "第48话 - 组织内幕", date: "2026-07-26" },
      { num: 47, title: "第47话 - 重要证人", date: "2026-07-19" },
    ],
  },
];

export const bannerComics = [
  {
    id: "jianmo-zhiwang",
    slug: "jianmo-zhiwang",
    title: "剑魔之王",
    originalTitle: "소드 데몬 킹",
    author: "吴泰宇",
    description: "被魔族抚养长大的人类少年，在得知自己真实身份后，踏上了寻找身世之谜的道路。拥有魔族之力和人类之心的他，将如何抉择？",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20epic%20fantasy%20banner%20style%20dark%20knight%20with%20demonic%20sword%20standing%20on%20cliff%20edge%20facing%20massive%20battlefield%20dramatic%20sky%20cinematic%20digital%20art%20illustration%20clean%20composition&width=1200&height=600&seq=banner-01&orientation=landscape",
    rating: 9.7,
    views: 8910000,
    tags: ["黑暗奇幻", "复仇", "王者归来"],
    chapters: 156,
    status: "连载中",
  },
  {
    id: "chongzu-zhilu",
    slug: "chongzu-zhilu",
    title: "重组之路",
    originalTitle: "재결성의 길",
    author: "尹智慧",
    description: "遭遇背叛的天才医生穿越到异世界，凭借现代医学知识在剑与魔法的世界中闯出一片天地。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20medical%20fantasy%20banner%20style%20doctor%20in%20white%20coat%20holding%20magical%20staff%20standing%20between%20modern%20hospital%20and%20fantasy%20world%20dramatic%20cinematic%20digital%20art%20illustration&width=1200&height=600&seq=banner-02&orientation=landscape",
    rating: 9.6,
    views: 7230000,
    tags: ["穿越", "医学", "异世界", "逆袭"],
    chapters: 98,
    status: "连载中",
  },
  {
    id: "tianshi-zhiyi",
    slug: "tianshi-zhiyi",
    title: "天使之翼",
    originalTitle: "천사의 날개",
    author: "郑秀晶",
    description: "失去记忆的天使坠落人间，与善良的人类女孩相遇。当记忆逐渐恢复，他必须在回归天界和留在人间之间做出选择。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20romance%20banner%20style%20angel%20with%20broken%20wings%20falling%20from%20sky%20reaching%20toward%20human%20girl%20ethereal%20golden%20light%20cinematic%20digital%20art%20illustration&width=1200&height=600&seq=banner-03&orientation=landscape",
    rating: 9.5,
    views: 5560000,
    tags: ["天使", "恋爱", "奇幻", "感人"],
    chapters: 67,
    status: "已完结",
  },
];

export const rankingComics = [
  { rank: 1, ...comics[2] },
  { rank: 2, ...comics[0] },
  { rank: 3, ...comics[5] },
  { rank: 4, ...comics[9] },
  { rank: 5, ...comics[11] },
  { rank: 6, ...comics[1] },
  { rank: 7, ...comics[10] },
  { rank: 8, ...comics[3] },
];